import api from "../../api";

/**
 * "Buyer Match" on the Prospects board (Christian Gravias, DOMA 13374913603):
 * how many CRM buyers fit each card, read off the card's property or, for a
 * seller lead, its Database owner profile. Backend:
 * buyer_portal/services/prospect_buyer_match.py.
 */

// Only the columns a buyer could still buy from.
export const MATCH_STAGES = ["new", "connected", "long_term", "appraisal", "listed", "for_sale"];

export const matchKey = (item) => `${item.kind}-${item.raw?.id}`;

// A rental lead is a landlord, not a seller (DOMA 13375194285).
export const matchable = (item) =>
  MATCH_STAGES.includes(item.stage) &&
  (item.kind === "lead" || item.kind === "property") &&
  item.raw?.id != null &&
  item.transactionType !== "rental";

// { counts, broad }: buyers who named the card's area, and those who named only
// a capital city ("Melbourne"), kept apart so interstate buyers don't inflate
// every card (DOMA 13374913603, 26 Oct 2026).
export const fetchBuyerCounts = async (items) => {
  const payload = items.filter(matchable).map((item) => ({ kind: item.kind, id: item.raw.id }));
  if (!payload.length) return { counts: {}, broad: {} };
  const res = await api.post("api/buyer-portal/analytics/find-buyers/prospect-counts/", { items: payload });
  return { counts: res.data?.counts || {}, broad: res.data?.broad_counts || {} };
};

export const fetchProspectBuyers = async (item) => {
  const res = await api.get("api/buyer-portal/analytics/find-buyers/prospect-buyers/", {
    params: { kind: item.kind, id: item.raw.id },
  });
  return res.data;
};
